
import { useState, useEffect } from "react";
import FormattedMessageContent from "./FormattedMessageContent";
import ExpandToggleButton from "./ExpandToggleButton";

interface MessageContentProps {
  content: string;
  isLatestMessage?: boolean;
}

const MessageContent = ({ content, isLatestMessage = false }: MessageContentProps) => {
  // Always expand latest message, otherwise respect user choice
  const [isExpanded, setIsExpanded] = useState(isLatestMessage);
  
  // For non-latest messages, determine if we should truncate
  const shouldTruncate = !isLatestMessage && content.length > 300 && !isExpanded;
  
  // Update expanded state when isLatestMessage changes
  useEffect(() => {
    if (isLatestMessage) {
      setIsExpanded(true);
    }
  }, [isLatestMessage]);
  
  const displayContent = shouldTruncate 
    ? content.substring(0, 300) + "..." 
    : content;
    
  // Find if there are key sections in the content for highlighting
  const hasKeyPoints = content.includes("- ") || content.includes("* ") || 
                      content.includes("## ") || content.includes("### ");

  return (
    <div className="space-y-2">
      {/* Visual indicator for complex content */}
      {hasKeyPoints && !shouldTruncate && (
        <div className="text-xs text-muted-foreground mb-2 flex items-center">
          <span className="inline-block w-1 h-1 bg-primary rounded-full mr-1"></span>
          Contains key points and structured information
        </div>
      )}
      
      <div className={isLatestMessage ? "animate-fade-in" : ""}>
        <FormattedMessageContent content={displayContent} />
      </div>
      
      {content.length > 300 && (
        <ExpandToggleButton 
          isExpanded={isExpanded} 
          onClick={() => setIsExpanded(!isExpanded)} 
        />
      )}
    </div>
  );
};

export default MessageContent;
